/**
 * SessionStorage for storing string values
 * https://filipmolcik.com/angular-2-local-storage/
 */
export function SessionStorage(
    target: Object, // The prototype of the class
    decoratedPropertyName: string // The name of the property
) {

    // get and set methods
    Object.defineProperty(target, decoratedPropertyName, {
        get: function () {
            const storedValue = sessionStorage.getItem(decoratedPropertyName);
            return storedValue ? JSON.parse(storedValue) : null;
        },
        set: function (newValue) {
            if (newValue === undefined) {
                sessionStorage.removeItem(decoratedPropertyName);
            } else {
                sessionStorage.setItem(decoratedPropertyName, JSON.stringify(newValue));
            }
        }
    });
}
